import React, { useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import useScrollAnimation from "../components/Hooks/useScrollAnimation";

import AppHome from "./AppHome.jsx";

import AboutSection from "../components/About";
import HeroBanner from "../components/HeroBanner";
import HomeIntro from "../components/HomeIntro";
import WhyChoose from "../components/WhyChooseUs";
import HowItWorks from "../pages/HowItWorks";
import { trackMetaCustomEvent } from "../utils/metaPixel";

import "../styles/components.css";

export default function Home() {
    // Native app: dashboard-style Home
    if (Capacitor.isNativePlatform()) {
        return <AppHome />;
    }

    // Web-only marketing behavior
    useScrollAnimation();

    useEffect(() => {
        window.scrollTo(0, 0);

        trackMetaCustomEvent("HomeLandingView", {
            location: "home",
            page_path: "/",
        });
    }, []);

    return (
        <div className="home-container">
            <section className="home-hero-section">
                <HeroBanner />
            </section>

            <HomeIntro />

            <section className="home-about-section">
                <AboutSection />
            </section>

            <section className="home-whychoose-section">
                <WhyChoose />
            </section>

            <section className="home-howitworks-section">
                <HowItWorks />
            </section>

            <section className="home-contact-strip">
                {/*<div className="home-contact-strip__inner">
                    <h2>Got a fresh adventure idea or need a hand planning your next stop?</h2>
                    <p>
                        {/*Email Form Area -> User Email Input -  //}
                    </p>
                </div>*/}
            </section>
        </div>
    );
}
